(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-journey"] && !Shopify.designMode) return;
  try {
    
  function processAjSpacers() {
    document.querySelectorAll('.about-journey .text-block').forEach((el) => {
      if (el.dataset.ajSpacers || !el.innerHTML.includes('[]')) return;
      el.innerHTML = el.innerHTML.replace(/\[\]/g, '<span class="aj-mobile-spacer"></span>');
      el.dataset.ajSpacers = '1';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAjSpacers);
  } else {
    processAjSpacers();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-rise"] && !Shopify.designMode) return;
  try {
    
  function processArSpacers() {
    document.querySelectorAll('.about-rise .text-block').forEach((el) => {
      if (el.dataset.arSpacers || !el.innerHTML.includes('[]')) return;
      el.innerHTML = el.innerHTML.replace(/\[\]/g, '<span class="ar-mobile-spacer"></span>');
      el.dataset.arSpacers = '1';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processArSpacers);
  } else {
    processArSpacers();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-tabs"] && !Shopify.designMode) return;
  try {
    
  class AboutTabs extends HTMLElement {
    #controller = new AbortController();
    #interval   = null;
    #current    = 0;

    static #DELAY = 4000; // ms entre tabs

    connectedCallback() {
      const { signal } = this.#controller;

      this.querySelectorAll('.about-tabs__item').forEach((item) => {
        item.addEventListener('click', (event) => this.#onUserClick(event), { signal });
      });

      this.#startAutoPlay();
    }

    disconnectedCallback() {
      this.#controller.abort();
      this.#stopAutoPlay();
    }

    // ─── Private ────────────────────────────────────────────

    /** Click del usuario: activa el tab y reinicia el timer */
    #onUserClick(event) {
      const index = parseInt(event.currentTarget.dataset.index, 10);
      this.#activate(index);
      this.#restartAutoPlay();
    }

    /** Activa un tab por índice */
    #activate(index) {
      const items    = this.querySelectorAll('.about-tabs__item');
      const contents = this.querySelectorAll('.about-tabs__content');
      const images   = this.querySelectorAll('.about-tabs__image-item');
      const total    = items.length;

      this.#current = ((index % total) + total) % total;

      items.forEach((el, i)    => el.classList.toggle('about-tabs__item--active',       i === this.#current));
      contents.forEach((el, i) => el.classList.toggle('about-tabs__content--active',    i === this.#current));
      images.forEach((el, i)   => el.classList.toggle('about-tabs__image-item--active', i === this.#current));
    }

    #startAutoPlay() {
      this.#interval = setInterval(() => {
        this.#activate(this.#current + 1);
      }, AboutTabs.#DELAY);
    }

    #stopAutoPlay() {
      if (this.#interval) {
        clearInterval(this.#interval);
        this.#interval = null;
      }
    }

    #restartAutoPlay() {
      this.#stopAutoPlay();
      this.#startAutoPlay();
    }
  }

  if (!customElements.get('sf-about-tabs')) {
    customElements.define('sf-about-tabs', AboutTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
class SfFooterForm extends HTMLElement {
  #abortController = null;
  #onSubmit = (event) => this.#handleSubmit(event);

  connectedCallback() {
    this.querySelector('form')?.addEventListener('submit', this.#onSubmit);
  }

  disconnectedCallback() {
    this.querySelector('form')?.removeEventListener('submit', this.#onSubmit);
    this.#abortController?.abort();
  }

  get #emailInput()    { return this.querySelector('[ref="emailInput"]'); }
  get #submitBtn()     { return this.querySelector('[ref="submitBtn"]'); }
  get #errorMessage()  { return this.querySelector('[ref="errorMessage"]'); }
  get #successMessage(){ return this.querySelector('[ref="successMessage"]'); }

  async #handleSubmit(event) {
    event.preventDefault();

    const email      = this.#emailInput?.value.trim();
    const companyId  = this.dataset.companyId;
    const listId     = this.dataset.listId;

    if (!email || !companyId || !listId) return;

    this.#abortController?.abort();
    this.#abortController = new AbortController();

    this.#submitBtn.disabled        = true;
    this.#errorMessage.hidden       = true;
    this.#successMessage.hidden     = true;

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`,
        {
          method: 'POST',
          signal: this.#abortController.signal,
          headers: {
            'content-type': 'application/json',
            'revision': '2024-10-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Footer newsletter',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email }
                  }
                }
              },
              relationships: {
                list: {
                  data: { type: 'list', id: listId }
                }
              }
            }
          })
        }
      );

      if (response.ok) {
        this.#successMessage.hidden = false;
        this.#emailInput.value = '';
      } else {
        this.#errorMessage.hidden = false;
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        this.#errorMessage.hidden = false;
      }
    } finally {
      this.#submitBtn.disabled = false;
    }
  }
}

if (!customElements.get('sf-footer-form')) {
  customElements.define('sf-footer-form', SfFooterForm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-collection-header"] && !Shopify.designMode) return;
  try {
    
(function initSortRemovePill() {
  function patch() {
    const url = new URL(window.location.href);
    url.searchParams.delete('sort_by');
    const removeUrl = url.toString();
    document.querySelectorAll('[data-sort-remove-pill]').forEach(function(pill) {
      pill.dataset.url = removeUrl;
    });
  }

  function init() {
    patch();
    // Re-patch whenever the drawer DOM changes (fires after AJAX section re-renders
    // that replace pill elements with fresh Liquid-rendered HTML).
    const drawer = document.getElementById('filters-drawer');
    if (drawer) {
      new MutationObserver(patch).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function initPromoModals() {
  function setup() {
    document.querySelectorAll('[data-promo-modal]').forEach(function(trigger) {
      const modalEl = document.getElementById(trigger.dataset.promoModal);
      if (!modalEl) return;

      const dialog = modalEl.querySelector('dialog');
      if (!dialog) return;

      trigger.addEventListener('click', function() {
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      });

      modalEl.querySelector('.sf-promo-modal__close').addEventListener('click', function() {
        dialog.close();
      });

      dialog.addEventListener('click', function(event) {
        if (event.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', function() {
        document.body.style.overflow = '';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-guarantee"] && !Shopify.designMode) return;
  try {
    
  const countryEl = document.getElementById('GuaranteeContactForm-country');
  const stateUSA = document.getElementById('sf-guarantee-state-usa');
  const stateCA = document.getElementById('sf-guarantee-state-ca');

  if (countryEl && stateUSA && stateCA) {
    countryEl.addEventListener('change', () => {
      const isCanada = countryEl.value === 'Canada';

      stateUSA.hidden = isCanada;
      stateUSA.querySelector('select').disabled = isCanada;

      stateCA.hidden = !isCanada;
      stateCA.querySelector('select').disabled = !isCanada;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["title-with-image"] && !Shopify.designMode) return;
  try {
    
  function processTwiSpacers() {
    document.querySelectorAll('.title-with-image .title-with-image__title, .title-with-image .title-with-image__subtitle').forEach((el) => {
      if (el.dataset.twiSpacers || !el.innerHTML.includes('[]')) return;
      el.innerHTML = el.innerHTML.replace(/\[\]/g, '<span class="twi-mobile-spacer"></span>');
      el.dataset.twiSpacers = '1';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processTwiSpacers);
  } else {
    processTwiSpacers();
  }

  } catch(e) { console.error(e); }
})();
})();
